import { ApiParameter, doesNotHaveExpand, get, patch, post, requestVoid } from "@insite/client-framework/Services/ApiService";
import { DeleteWishListLinesApiParameter } from "@insite/client-framework/Services/WishListService";
import { BaseModel, SortOptionModel, WishListModel } from "@insite/client-framework/Types/ApiModels";

const wishListUrl = "/api/v2/wishlists";

const wishListUrlUpdate = "/api/v1/wishlists";

const cartsUrl = "/api/v1/carts";

export interface GetWishListApiParameter extends ApiParameter {
    wishListId: string;
    exclude?: "listLines"[];
    expand?: ("schedule" | "sharedUsers" | "staticList" | "getAllLines")[];
    name?: string;
    parameter?: WishListApiParameter;
}

export interface WishListApiParameter {
    currentPage?: number | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    defaultPageSize?: number | undefined;
    totalItemCount?: number | undefined;
    numberOfPages?: number | undefined;
    pageSizeOptions?: number[] | undefined;
    sortOptions?: SortOptionModel[] | undefined;
    sortType?: string | undefined;
    nextPageUri?: string | undefined;
    prevPageUri?: string | undefined;
}
export interface NewCartLine {
    productId: string;
    qtyOrdered: number;
}
export interface CartLineCollectionModel extends BaseModel {
    cartLines: NewCartLine[];
}

export interface AddCartLinesApiParameter extends ApiParameter {
    cartId: string;
    cartLineCollection: CartLineCollectionModel;
}

export interface UpdateWishListLineApiParameter extends ApiParameter {
    wishListId?: string;
    wishList?: WishListModel;
    wishListLineId: string;
}

export async function getWishList(apiParameter: GetWishListApiParameter) {
    const { wishListId, name, parameter } = apiParameter;

    const queryParameters = {
        wishListId: wishListId,
        name: name,
        ...parameter,
    };

    const wishList = await get<WishListModel>(`${wishListUrl}/${wishListId}`, {
        // params: queryParameters,
        name,
        parameter,
    } as any);
    cleanWishList(wishList, apiParameter);
    return wishList;
}

export function deleteWishListLines(parameter: DeleteWishListLinesApiParameter) {
    const query = parameter.wishListLineIds.map(o => `wishListLineIds=${o}`).join("&");
    return requestVoid(`${wishListUrl}/${parameter.wishListId}/wishlistlines/batch?${query}`, "DELETE", {
        "Content-Type": "application/json",
    });
}

export function addLineCollection(parameter: any) {
    return post(`${cartsUrl}/${parameter.cartId}/cartlines/batch`, parameter.cartLineCollection);
}

export async function updateWishListProdutLine(parameter: UpdateWishListLineApiParameter) {
    const wishList = await patch<WishListModel>(
        `${wishListUrlUpdate}/${parameter.wishListId}/wishlistlines/${parameter.wishListLineId}`,
        parameter.wishList ? parameter.wishList : {},
    );
    return wishList;
}

function cleanWishList(wishList: WishListModel, parameter?: GetWishListApiParameter) {
    if (doesNotHaveExpand(parameter, "schedule")) {
        wishList.schedule = null;
    }
    if (doesNotHaveExpand(parameter, "sharedUsers")) {
        wishList.sharedUsers = null;
    }
    if (parameter?.exclude && parameter?.exclude.indexOf("listLines") > -1) {
        wishList.wishListLineCollection = null;
        wishList.wishListLinesCount = -1;
    }
}
